import { useState, useEffect } from 'react';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    
    // Roep de handler direct aan om de initiële grootte te krijgen
    handleResize();

    // Cleanup functie om de event listener te verwijderen
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Lege array zorgt ervoor dat dit effect maar 1x runt

  return windowSize;
}

export default useWindowSize;